import { render } from "./dashboard-appointment.vue?vue&type=template&id=411ae7f6"
import script from "./dashboard-appointment.vue?vue&type=script&lang=js"
export * from "./dashboard-appointment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__